import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";

const AssetAttachment = ({assetData}) => {

    const [attachmentData, setAttachmentData] = useState([]) 

  useEffect(()=>{
    console.log(assetData)
            const attachments = assetData
            setAttachmentData(attachments) 
  },[assetData])  

  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };


  return (
    <>
      <div className="tab-content">
        <div id="emp_profile" className="pro-overview tab-pane fade show active">            
          <div className="mail-attachments">
            <p>
                <i className="fa-solid fa-paperclip" /> {assetData?.length} Attachments {" "}
          
              
            </p>
            <ul className="attachments clearfix">
            {attachmentData?.length > 0 ? (
                    <>
                        {attachmentData?.map((item, index) => (
                <ListItem
                id={item.id}
                key={index}
                item={item}
                download={handleDownloadAll}
                />
            ))}
                    </>
                    ) : (
                    <div></div>
                    )}

              

                
            </ul>
          </div>              
        </div>  

   
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />
    </>
  );
};

export const ListItem = ({ item, download }) => (
    <li>
    <div className="attach-file">
      {
        item?.url.split(".").pop() == "pdf" ?
          <i className="fa-solid fa-file-pdf"></i>
       
        :
        <img style={{ height: '130px'}} src={item.url} alt="" />
      }
        
    </div>
    <div className="attach-info align-right d-flex justify-content-end ">
        {" "}
        <Link to={item?.url} target="_blank" className="attach-filename" >
        <i className="fa-solid fa-eye"></i>
        </Link>
        <div className="ms-2" />
        <Link to="#" className="attach-filename" onClick={() => download(item)}  >
           <i className="attach-fileize fa-solid fa-download"/>
        </Link>{" "}      
    </div>
</li>
  );

export default AssetAttachment;
